/**
 * Troca a foto exibida no carrinho (página /cart e gaveta) pela foto da cor
 * de lente que o cliente escolheu, usando a property oculta "_preview_image"
 * (gravada pelo lens-selector.js no momento de adicionar ao carrinho).
 *
 * Properties que começam com "_" não aparecem na listagem visual de
 * properties do item, mas continuam disponíveis na resposta de /cart.js.
 */
(async function () {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
 
    for (const item of cart.items) {
      const previewImage = item.properties && item.properties['_preview_image'];
      if (!previewImage) continue;
 
      const rows = document.querySelectorAll(`[data-key="${item.key}"]`);
 
      rows.forEach((row) => {
        const img = row.querySelector('.cart-items__media-image');
        if (!img) return;
 
        img.src = previewImage;
        img.removeAttribute('srcset');
      });
    }
  } catch (error) {
    console.error('[cart-image-override] erro ao trocar a foto do carrinho:', error);
  }
})();
 